@if (showTrigger()) {
  <se-fe-modal-button [seFeDataButton]="{icon: true}" (seFeButtonAction)="open($event)">
    <se-fe-icon
      seFeModalIcon
      seFeDataName="edit"
      seFeDataSize="500"
      seFeDataColor="default"
      seFeDataAriaLabel="Edit variant inventory"></se-fe-icon>
  </se-fe-modal-button>
}

<se-fe-modal seFeDataSize="large" #inventoryModal (seFeAfterClose)="reset()">
  <div seFeModalHeader>
    <se-fe-modal-header seFeDataTitle="Edit Product Variant Inventory"></se-fe-modal-header>
  </div>

  <se-fe-modal-content>
    @if (inventoryModal.isOpen || inventoryModal.closing) {
      <form [formGroup]="form" novalidate>
        <se-fe-table-wrapper>
          <table seFeTable title="Product variant inventory" [dataSource]="inventoryDatasource">
            <ng-container seFeColumnDef="name">
              <th seFeHeaderCell *seFeHeaderCellDef>Variant</th>
              <td seFeCell *seFeCellDef="let row">{{ row.name }}</td>
            </ng-container>
            <ng-container seFeColumnDef="inventory">
              <th seFeHeaderCell *seFeHeaderCellDef>Quantity available</th>
              <td seFeCell *seFeCellDef="let row">
                <se-fe-form-field [seFeDataConfig]="inventoryConfig" class="inventory-field">
                  <se-fe-form-field-quantity
                    [formControlName]="'' + row.id"
                    [seFeDataMin]="inventoryMin"
                    [seFeEnableManualInput]="true"></se-fe-form-field-quantity>
                </se-fe-form-field>
              </td>
            </ng-container>
            <tr seFeHeaderRow *seFeHeaderRowDef="tableColumns"></tr>
            <tr seFeRow *seFeRowDef="let row; columns: tableColumns"></tr>
          </table>
        </se-fe-table-wrapper>
      </form>

      <se-fe-alert seFeDataType="info" class="inventory-help">
        Leave a quantity blank to make that variant unlimited. When you sell products, the quantity available is reduced
        automatically.
      </se-fe-alert>

      @if (inventoryChangedWhileEditing()) {
        <se-fe-alert seFeDataType="caution">
          Quantity changed while you were editing. Confirm save to keep the quantities you entered.
        </se-fe-alert>
      }

      @if (saveError()) {
        <se-fe-alert seFeDataType="error">{{ saveError() }}</se-fe-alert>
      }

      <div class="inventory-modal-footer">
        <se-fe-button seFeDataEmphasis="low" [seFeDataIsDisabled]="saving()" (click)="close()">Cancel</se-fe-button>
        <se-fe-button seFeDataEmphasis="high" [seFeDataIsLoading]="saving()" (click)="save()">
          {{ inventoryChangedWhileEditing() ? 'Confirm save' : 'Save' }}
        </se-fe-button>
      </div>
    }
  </se-fe-modal-content>
</se-fe-modal>
